import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import EmergencyExportView from '../../../Share/partials/EmergencyExportView';
import { injectIntl } from 'react-intl';
import { renderHeaderButton } from '../../../../store/headerButtonControl/duck';
import { updateUserDetails } from '../../../../store/user/duck';
import {
  getEmergencyExport,
  updateEmergencyExport,
  updateEmergencyExportInputs
} from '../../../../store/emergencyExport/duck';
import { toggleControl } from '../../../../store/control/duck';
import { updateViewingClient } from '../../../../store/client/duck';
import { clientToView } from '../../../../utils/viewing-client';

const AdvisorEmergencyExportWrapper = props => {
  const {
    intl,
    clientId,
    emergencyExport,
    renderHeaderButton,
    getEmergencyExport,
    clientData,
    viewingClient,
    updateViewingClient
  } = props;

  const localStorageClientId = window.localStorage.getItem('clientId');
  const finalClientId = clientId ? clientId : localStorageClientId ? JSON.parse(localStorageClientId) : undefined;

  useEffect(() => {
    renderHeaderButton(false);
  }, [renderHeaderButton]);

  // Callers can route here with only an id (e.g. the post-save "View PDF" button), which
  // leaves EmergencyExportView and the SOS paper edit page reading a stale viewingClient.
  useEffect(() => {
    const client = clientToView(clientData, viewingClient, finalClientId);
    if (client) {
      updateViewingClient(client);
    }
  }, [clientData, viewingClient, finalClientId, updateViewingClient]);

  useEffect(() => {
    getEmergencyExport(finalClientId);
  }, [finalClientId, getEmergencyExport]);

  return (
    <div>
      {finalClientId !== undefined ? (
        <div>
          <EmergencyExportView {...props} previousPage="/client" emergencyExport={emergencyExport} />
        </div>
      ) : (
        <div>
          <div id="wrapper">
            <div id="page-content-wrapper">
              <div className="container-fluid emergency-view-padding">
                <h3 className="text-center">{intl.formatMessage({ id: 'No Client is Selected!' })}</h3>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const container = connect(
  // Map state to props
  state => ({
    userDetails: state.user.userDetails,
    updatePhase: state.user.updatePhase,
    loading: state.emergencyExport.loading,
    emergencyExport: state.emergencyExport.emergencyExport,
    userSubscription: state.userSubscription.userSubscription,
    clientData: state.client.clientData,
    viewingClient: state.client.viewingClient
  }),
  {
    renderHeaderButton,
    updateUserDetails,
    updateEmergencyExportInputs,
    getEmergencyExport,
    updateEmergencyExport,
    toggleControl,
    updateViewingClient
  }
)(AdvisorEmergencyExportWrapper);

export default injectIntl(container);
